
import { Injectable } from '@angular/core';
import { FilterInfo } from '../models/filter-info.model';
import { IHandlerLocal } from './handler';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class HandlerLocal implements IHandlerLocal {
  constructor(private datePipe: DatePipe) { }
  filter = (localItems: any[], filterInfo: FilterInfo) => {
    const items = localItems.filter(item => {
      for (const column of filterInfo.columns) {
        const filterValue: string = (filterInfo.rawFilter[column.field] || '').toString().trim().toLowerCase();
        const columnValue: string = (item[column.field] || '').toString().trim().toLowerCase();
        if (filterValue) {
          if (!columnValue) {
            return false;
          }
          if (column.type === 'string') {
            if (columnValue.indexOf(filterValue) === -1) {
              return false;
            }
          } else if (column.type === 'values' || column.type === 'radio') {
            if (columnValue !== filterValue) {
              return false;
            }
          } else if (column.type === 'number') {
            const fValue = +filterValue.replace('>=', '').replace('<=', '').replace('>', '').replace('<', '');
            const cValue = +columnValue;
            if (fValue || fValue === 0) {
              if (!cValue && cValue !== 0) {
                return false;
              }
              if (filterValue.indexOf('>=') > -1 && cValue < fValue) {
                return false;
              } else if (filterValue.indexOf('<=') > -1 && cValue > fValue) {
                return false;
              } else if (filterValue.indexOf('<') > -1 && cValue >= fValue) {
                return false;
              } else if (filterValue.indexOf('>') > -1 && cValue <= fValue) {
                return false;
              } else if (cValue !== fValue) {
                return false;
              }
            }
          } else if (column.type === 'bool') {
            if (filterValue === '1' && columnValue !== '1' && columnValue !== 'true') {
              return false;
            } else if (filterValue === '0' && columnValue !== '0' && columnValue !== 'false') {
              return false;
            }
          } else if (column.type === 'date' || column.type === 'datetime') {
            const date = this.datePipe.transform(filterValue, 'yyyy/MM/dd');
            const fromDate = new Date(date);
            const toDate = new Date(date);
            toDate.setDate(toDate.getDate() + 1);
            if (new Date(columnValue).getTime() < fromDate.getTime() || new Date(columnValue).getTime() >= toDate.getTime()) {
              return false;
            }
          }
        }
      }
      return true;
    });
    // Sort
    if (filterInfo.orderBy && filterInfo.orderDirection) {
      const column = filterInfo.columns.find(e => e.field === filterInfo.orderBy);
      if (column) {
        const { type, field } = column;
        items.sort((current, next) => {
          if (type === 'number') {
            return (current[field] || 0) - (next[field] || 0);
          }
          if (type === 'date' || type === 'datetime' || type === 'time') {
            const d1 = new Date(current[field] || '').getTime();
            const d2 = new Date(current[field] || '').getTime();
            return d1 - d2;
          }
          const s1 = (current[field] || '').toString();
          const s2 = (next[field] || '').toString();
          if (s1 > s2) {
            return 1;
          }
          if (s1 < s2) {
            return -1;
          }
          return 0;
        });
        if (filterInfo.orderDirection === 'DESC') {
          items.reverse();
        }
      }
    }
    return {
      items,
      total: items.length
    };
  }
}
